import Chart from 'chart.js';

Chart.Legend.prototype.afterFit = function() {
    this.height = this.height + 10;
};

export default {
    data() {
        return {
            chartFrequency: null,
            chartValue: null,
            chartVolume: null,
            colors: { blue: { bg: 'rgb(25, 118, 210, 0.2)', border: 'rgb(25, 118, 210, 0.4)' },
                      green: { bg: 'rgb(102, 187, 106, 0.2)', border: 'rgb(102, 187, 106, 0.6)' },
                      red: { bg: 'rgb(229, 57, 53, 0.2)', border: 'rgb(229, 57, 53, 0.4)' },
                      redDark: { bg: 'rgb(213, 0, 0, 0.2)', border: 'rgb(213, 0, 0, 0.8)' }}
        }
    },
    methods: {
        renderTransactionsFrequency(canvas, data, report, weekday = false) {
            
            let chartData = { datasets: [] };
            let transactions = [];
            let labels = [];
            let bgColor = [];
            let borderColor = [];
            let borderWidth = [];
            let min = [];
            let max = [];

            for(let i = 0; i < data.length; i++) {

                if(typeof data[i+1] !== 'undefined' && data[i].hour == data[i+1].hour) {
                    transactions.push(data[i].transactions);   
                    if(report == 'full') { bgColor.push(this.colors.blue.bg); borderColor.push(this.colors.blue.border); }
                    if(report == 'min') { bgColor.push(this.colors.green.bg); borderColor.push(this.colors.green.border); }
                    if(report == 'max') { bgColor.push(this.colors.red.bg); borderColor.push(this.colors.red.border); }   
                    borderWidth.push(0.5);
                }
                else {
                    transactions.push(data[i].transactions);
                    if(report == 'full') { bgColor.push(this.colors.blue.bg); borderColor.push(this.colors.blue.border); }
                    if(report == 'min') { bgColor.push(this.colors.green.bg); borderColor.push(this.colors.green.border); }
                    if(report == 'max') { bgColor.push(this.colors.red.bg); borderColor.push(this.colors.red.border); } 
                    borderWidth.push(0.5);

                    if(weekday) {
                        min.push(Math.min(...transactions.slice(0, 5)));
                        max.push(Math.max(...transactions.slice(0, 5)));
                    }
                    else {
                        min.push(Math.min(...transactions));
                        max.push(Math.max(...transactions));
                    }
       
                    if(data[i].hour != 23) {
                        labels.push(`Average number of transactions between ${data[i].hour}:00 - ${data[i+1].hour}:00`);
                    }
                    else {
                        labels.push(`Average number of transactions between ${data[i].hour}:00 - 0:00`);
                    }

                    chartData.datasets.push({ label: labels, data: transactions, min: min, max: max, backgroundColor: bgColor, borderColor: borderColor, borderWidth: borderWidth });
                    transactions = [];
                    labels = [];
                    bgColor= [];
                    borderColor = [];
                    borderWidth = [];
                    min = [];
                    max = [];
                }
            }

            if(report == 'full') {
                chartData.datasets.forEach((item, index) => {
                    let i = item.data.findIndex(e => e == item.min);
                    let j = item.data.findIndex(e => e == item.max);

                    chartData.datasets[index].backgroundColor[i] = this.colors.green.bg;
                    chartData.datasets[index].borderColor[i] = this.colors.green.border;
                    chartData.datasets[index].backgroundColor[j] = this.colors.red.bg;
                    chartData.datasets[index].borderColor[j] = this.colors.red.border;
                });
            }

            if(this.chartFrequency) {
                this.chartFrequency.destroy();
            }

            this.chartFrequency = new Chart(canvas, {
                type: 'bar',
                data: {
                    labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                    datasets: chartData.datasets
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                                
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Transactions'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            },
                            categoryPercentage: 0.95,
                            barPercentage: 0.6
                        }]
                    },
                    legend: {
                        display: false,
                        labels: {
                            fontSize: 10
                        }
                    }
                }
            })
        },
        renderTransactionsValueComparison(canvas, data, duration) {

            let dataRev = [...data].reverse()
            let labels = [];
            let chartData = { datasets: [] };
            let dbVal = [];
            let crVal = [];
            let dbFailVal = [];
            let failureRateVal = [];
            let title = null;

            if(duration == 'weekly') {
                dataRev.forEach((item) => { labels.push(item.day); dbVal.push(item.dbVal); crVal.push(item.crVal); dbFailVal.push(item.dbFailVal); failureRateVal.push(item.failureRateVal) });
                title = 'Weekly Transactions Value Comparison';
            }
            else {
                dataRev.forEach((item) => { labels.push(item.monthName); dbVal.push(item.dbVal); crVal.push(item.crVal); dbFailVal.push(item.dbFailVal); failureRateVal.push(item.failureRateVal) });
                title = 'Monthly Transactions Value Comparison';
            }
            chartData.datasets.push({ label: 'Debit', data: dbVal, backgroundColor: this.colors.green.bg, borderColor: this.colors.green.border, borderWidth: 2, fill: false });
            chartData.datasets.push({ label: 'Credit', data: crVal, backgroundColor: this.colors.blue.bg, borderColor: this.colors.blue.border, borderWidth: 2, fill: false });
            chartData.datasets.push({ label: 'Rejected Debit', data: dbFailVal, backgroundColor: this.colors.red.bg, borderColor: this.colors.red.border, borderWidth: 2, fill: false });
            chartData.datasets.push({ yAxisID: 2, label: 'Failure Rate', data: failureRateVal, backgroundColor: this.colors.redDark.bg, borderColor: this.colors.redDark.border, borderDash: [2], borderWidth: 0.7, fill: false });

            if(this.chartValue) {
                this.chartValue.destroy();
            }

            this.chartValue = new Chart(canvas, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: title,
                        fontFamily: "'Avenir', 'Helvetica', 'Arial', 'sans-serif'",
                        fontStyle: '500'
                    },
                    scales: {
                        yAxes: [{
                            positions: 'left',
                            ticks: {
                                id: 1,
                                beginAtZero: true,
                                fontSize: 10,
                                callback: function(value) {
                                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(value);
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Value',
                                fontSize: 12
                            }
                        },
                        {
                            id: 2,
                            position: 'right',
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                callback: function(value) {
                                    return `${new Intl.NumberFormat().format(value)}%`;
                                }
                            },
                            gridLines: {
                                display: false
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10
                            }
                        }]
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 10,
                            boxWidth: 20,
                            usePointStyle: true
                        },   
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltip) {
                                if(tooltip.datasetIndex != 3) {
                                    return `Value: ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(tooltip.value)}`;
                                }
                                else {
                                    return `Failure Rate: ${tooltip.value}%`;
                                }
                            }
                         }
                    }
                }
            })
        },
        renderTransactionsVolumeComparison(canvas, data, duration) {

            let dataRev = [...data].reverse()
            let labels = [];
            let chartData = { datasets: [] };
            let dbVol = [];
            let crVol = [];
            let dbFailVol = [];
            let failureRateVol = [];
            let title = null;

            if(duration == 'weekly') {
                dataRev.forEach((item) => { labels.push(item.day); dbVol.push(item.dbVol); crVol.push(item.crVol); dbFailVol.push(item.dbFailVol); failureRateVol.push(item.failureRateVol) });
                title = 'Weekly Transactions Volume Comparison';
            }
            else {
                dataRev.forEach((item) => { labels.push(item.monthName); dbVol.push(item.dbVol); crVol.push(item.crVol); dbFailVol.push(item.dbFailVol); failureRateVol.push(item.failureRateVol) });
                title = 'Monthly Transactions Volume Comparison'
            }
            chartData.datasets.push({ label: 'Debit', data: dbVol, backgroundColor: this.colors.green.bg, borderColor: this.colors.green.border, borderWidth: 2, fill: false });
            chartData.datasets.push({ label: 'Credit', data: crVol, backgroundColor: this.colors.blue.bg, borderColor: this.colors.blue.border, borderWidth: 2, fill: false });
            chartData.datasets.push({ label: 'Rejected Debit', data: dbFailVol, backgroundColor: this.colors.red.bg, borderColor: this.colors.red.border, borderWidth: 2, fill: false });
            chartData.datasets.push({ yAxisID: 2, label: 'Failure Rate', data: failureRateVol, backgroundColor: this.colors.redDark.bg, borderColor: this.colors.redDark.border, borderDash: [2], borderWidth: 0.7, fill: false });

            if(this.chartVolume) {
                this.chartVolume.destroy();
            }

            this.chartVolume = new Chart(canvas, {
                type: 'line',
                data: {
                    labels: labels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: title,
                        fontFamily: "'Avenir', 'Helvetica', 'Arial', 'sans-serif'",
                        fontStyle: '500'
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                callback: function(value) {
                                    return new Intl.NumberFormat().format(value);
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Volume',
                                fontSize: 12
                            }
                        },
                        {
                            id: 2,
                            position: 'right',
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                callback: function(value) {
                                    return `${new Intl.NumberFormat().format(value)}%`;
                                }
                            },
                            gridLines: {
                                display: false
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10
                            }
                        }]
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 10,
                            boxWidth: 20,
                            usePointStyle: true
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltip) {
                                if(tooltip.datasetIndex != 3) {
                                    return `Transactions: ${new Intl.NumberFormat().format(tooltip.value)}`;
                                }
                                else {
                                    return `Failure Rate: ${tooltip.value}%`;
                                }
                            }
                         }
                    }
                }
            })
        }
    }
}
